// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q2G6xRkNfxsgBJOgBLCK {
  display: inline-block;
  list-style: none;
  padding: 0.2em 0.4em;
  margin: 0;
  background-color: var(--dry-bg);
  border: var(--dry-border);
  border-radius: var(--dry-border-radius);
  user-select: none;
  box-shadow: var(--dry-shadow);
  display: grid;
  grid-template-columns: 1fr auto;
}
.Q2G6xRkNfxsgBJOgBLCK.checklist > li {
  padding-left: 2em;
}
.Q2G6xRkNfxsgBJOgBLCK > li {
  cursor: pointer;
  padding: 0.5em 1em;
  white-space: nowrap;
  border-radius: var(--dry-border-radius);
  position: relative;
  grid-column: span 2;
  display: grid;
  grid-template-columns: subgrid;
  gap: 1em;
}
.Q2G6xRkNfxsgBJOgBLCK > li:hover {
  background-color: var(--dry-hover-bg);
}
.Q2G6xRkNfxsgBJOgBLCK > li.yy6OYcuJR76KnKsjviWf {
  margin-bottom: 0.6em;
}
.Q2G6xRkNfxsgBJOgBLCK > li.yy6OYcuJR76KnKsjviWf::after {
  position: absolute;
  inset: auto 0 -0.3em 0;
  height: var(--dry-border-width);
  background-color: var(--dry-border-color);
  content: "";
}
.Q2G6xRkNfxsgBJOgBLCK > li > :first-child {
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 0.2em;
}
.Q2G6xRkNfxsgBJOgBLCK > li > :first-child > svg {
  width: 1.4em;
  height: 1.2em;
}
.Q2G6xRkNfxsgBJOgBLCK > li > :first-child > svg path {
  fill: var(--dry-color);
}
.Q2G6xRkNfxsgBJOgBLCK > li > :last-child {
  text-align: right;
  font-size: 0.9em;
  opacity: 0.6;
}
.Q2G6xRkNfxsgBJOgBLCK > li.checked {
  padding-left: 0.4em;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Q2G6xRkNfxsgBJOgBLCK`,
	"separator": `yy6OYcuJR76KnKsjviWf`
};
export default ___CSS_LOADER_EXPORT___;
